module.exports = __webpack_public_path__ + "static/azulesPorUnDia-f8da7c4cf568ff2e0d32a23ac451d140.png";